import { View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { ImageViewerTrigger } from '@/components/ImageViewer'
import SectionHeader from '@/components/SectionHeader'

export function ImageViewerSection({ images }: { images: string[] | null }) {
  const { t } = useTranslation()
  if (images === null) {
    return null
  }

  return (
    <>
      <SectionHeader>{t('orders:paymentProof')}</SectionHeader>
      <View className={'flex-row gap-2 border-y border-border-10 bg-background-primary px-4 py-[15px]'}>
        {[0, 1, 2].map((element) => (
          <View key={element} className={'h-20 flex-1'}>
            {images.length > element && <ImageViewerTrigger source={images[element]} />}
          </View>
        ))}
      </View>
    </>
  )
}
